
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"60","height":"60","viewBox":"0 0 60 60","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('circle',{attrs:{"cx":"30","cy":"30","r":"16","fill":"#F2F3F5"}}),_c('path',{attrs:{"d":"M25.886 25.886a3.876 3.876 0 013.936-2.997 3.797 3.797 0 014 3.555C33.822 29.118 30 30 30 31.778","stroke":"#EE8F00","stroke-width":"2.5","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M30 36.444c.123 0 .223.1.223.222","stroke":"#EE8F00","stroke-width":"3","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    